import {
  LitElement,
  html,
  css,
  utils,
  styles,
} from '@hh/global.js'

const { getCookie, serializeForm, addToCart } = utils

class HHShippingEstimator extends LitElement {
  static properties = {
    context: {
      type: String
    }
  }

  constructor() {
    super()

    this.countrySelector = this.querySelector('[name="country"]')
    this.provinceSelector = this.querySelector('[name="province"]')
    this.zipInput = this.querySelector('[name="zip"]')
    this.submitButton = this.querySelector('.js-submit')

    this.estimateContainer = this.querySelector('.js-shipping-estimator')
    this.resultsContainer = this.querySelector('.js-results')
    this.resultListContainer = this.querySelector('.js-results')

    this.country = this.countrySelector.value
    this.province = ''
  }

  connectedCallback() {
    super.connectedCallback()

    this.initSelection()
    this.provinceSelector.addEventListener('change', this.onProvinceChange.bind(this))
    this.submitButton.addEventListener('click', this.handleSubmit.bind(this))
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    this.provinceSelector.removeEventListener('change', this.onProvinceChange)
    this.submitButton.removeEventListener('click', this.handleSubmit)
  }

  initSelection () {
    const provinces = JSON.parse(this.countrySelector.querySelector(`option[value="${this.country}"]`).dataset.provinces || '{}')
    const provinceOptions = provinces.map(province => ({
      label: province[1],
      value: province[0]
    }))

    this.province = ''

    provinceOptions.forEach(option => {
      const opt = document.createElement('option')
      opt.value = option.value;
      opt.innerHTML = option.label
      this.provinceSelector.appendChild(opt)
    })
  }

  showEstimator (e) {
    e.target.classList.add('hidden')
    this.estimateContainer.classList.remove('hidden')
  }

  onProvinceChange (e) {
    this.province = e?.target?.value
  }

  handleSubmit (e) {
    if (this.context === 'product') {
      this.fetchRatesForProduct(e.target.form)
    } else {
      this.fetchRatesForCart()
    }
  }

  async fetchRatesForProduct (form) {
    const formData = JSON.parse(serializeForm(form))
    const cartCookie = getCookie('cart'),
      tempCookieValue = 'temp-cart-cookie___' + Date.now() + parseInt(Math.random() * 1000);

    this.setCartCookie(tempCookieValue)

    await addToCart(formData)
    const results = await this.fetchRates()

    this.formatResults(results)
    this.setCartCookie(cartCookie)
  }

  async fetchRatesForCart () {
    const results = await this.fetchRates()

    this.formatResults(results)
  }

  async fetchRates () {
    const results = await fetch(`${window.routes.cart_url}/shipping_rates.json?` + new URLSearchParams({
        'shipping_address[zip]': this.zipInput?.value,
        'shipping_address[province]': this.province,
        'shipping_address[country]': this.country
      })
    ).then(response => response.json())

    return results
  }

  formatResults (results) {
    this.querySelector('.js-results').classList.remove('hidden')

    if (results.shipping_rates) {
      this.querySelector('.js-results-description').innerHTML = window.cartStrings.shippingEstimateResults.replace('[num]', results.shipping_rates.length)
      this.querySelector('.js-results-error').classList.add('hidden')
      this.querySelector('.js-results-success').classList.remove('hidden')
      this.querySelector('.js-success-list').innerHTML = results.shipping_rates.map(result => `<li>${result.name}: ${window.cartStrings.currencySymbol}${result.price}</li>`).join('')
    } else {
      this.querySelector('.js-results-success').classList.add('hidden')
      this.querySelector('.js-results-error').classList.remove('hidden')
      this.querySelector('.js-error-list').innerHTML = Object.keys(results).map(key => results[key]).flat().map(message => `<li>${message}</li>`).join('')
    }
  }

  setCartCookie (value) {
    const date = new Date()
    date.setTime(date.getTime() + 14 * 86400000)
    document.cookie = `cart=${value}; expires=${date.toUTCString()}; path=/`
  }

  render() {
    return html`
        <slot
          @toggle="${this.showEstimator}"
        ></slot>
    `
  }

  static styles = [
    styles.visuallyHidden,
    css`
      :host {
        display: block;
        position: relative;
      }
    `,
  ]
}

customElements.define('hh-shipping-estimator', HHShippingEstimator)
